// useIsMounted.js
import { useRef, useEffect } from 'react';

const useIsMounted = () => {
  const isMounted = useRef(false);
  useEffect(() => {
    isMounted.current = true;
  }, []);
  return isMounted;
};

export default useIsMounted;